import Vue from 'vue';



export default Vue.extend({

  name: 'AlertDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },

  methods: {
    confirm(): void {
      this.$emit('onConfirm');
    }
  }



});
